var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-applications"},[_c('div',{staticClass:"all-applications__content"},_vm._l((_vm.cards),function(card,cardIndex){return _c('Card',{key:cardIndex,attrs:{"card":card,"card-index":cardIndex,"is-loaded":_vm.isLoaded,"search-fields":['title', 'bundle_id']},on:{"addApp":_vm.addApp,"editApp":_vm.editApp}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }